import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'
import './styles/theme-transitions.css'
import './i18n'
import App from './App.tsx'
// === AGENT_A (Field App) BEGIN ===
import { drainOnce } from '@/hooks/useSyncQueue'
// === AGENT_A (Field App) END ===
// === AGENT_G (Sentry frontend + PostHog) BEGIN ===
import { initSentry } from '@/observability/sentry'
import { initPostHog } from '@/observability/posthog'

initSentry()
initPostHog()
// === AGENT_G (Sentry frontend + PostHog) END ===
// === NAV_V2 (Theme System) BEGIN ===
import { ThemeProvider } from '@/lib/theme'
// === NAV_V2 (Theme System) END ===
// === Phase 2 Agent D2 BEGIN ===
import { InstallPWAPrompt } from '@/components/InstallPWAPrompt'
// === Phase 2 Agent D2 END ===

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
        {/* === Phase 2 Agent D2 BEGIN === */}
        <InstallPWAPrompt />
        {/* === Phase 2 Agent D2 END === */}
        <Toaster
          position="top-center"
          richColors
          closeButton
          duration={4000}
        />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)

// === AGENT_A (Field App) BEGIN ===
// Module 2.7 Phase 3 Part 1 -- service worker registration.
// The SW is best-effort: registration failure is logged and the rest
// of the app keeps working (the foreground replayer still drains the
// queue on online/interval).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => {
        console.warn('[field-app] service worker registration failed', err)
      })
  })
  // The SW nudges us via postMessage when the browser fires its
  // periodic Background Sync. We invoke drainOnce() directly so we
  // don't wait for the React tree to mount its replayer effect.
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'bm-field-sync:drain') {
      void drainOnce()
    }
  })
}
// === AGENT_A (Field App) END ===
